/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RocketWarehouseResVo } from './RocketWarehouseResVo';
import {
    RocketWarehouseResVoFromJSON,
    RocketWarehouseResVoFromJSONTyped,
    RocketWarehouseResVoToJSON,
    RocketWarehouseResVoToJSONTyped,
} from './RocketWarehouseResVo';

/**
 * 
 * @export
 * @interface ResponseRocketWarehouseResVo
 */
export interface ResponseRocketWarehouseResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseRocketWarehouseResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseRocketWarehouseResVo
     */
    message?: string;
    /**
     * 
     * @type {RocketWarehouseResVo}
     * @memberof ResponseRocketWarehouseResVo
     */
    data?: RocketWarehouseResVo;
}

/**
 * Check if a given object implements the ResponseRocketWarehouseResVo interface.
 */
export function instanceOfResponseRocketWarehouseResVo(value: object): value is ResponseRocketWarehouseResVo {
    return true;
}

export function ResponseRocketWarehouseResVoFromJSON(json: any): ResponseRocketWarehouseResVo {
    return ResponseRocketWarehouseResVoFromJSONTyped(json, false);
}

export function ResponseRocketWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseRocketWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RocketWarehouseResVoFromJSON(json['data']),
    };
}

export function ResponseRocketWarehouseResVoToJSON(json: any): ResponseRocketWarehouseResVo {
    return ResponseRocketWarehouseResVoToJSONTyped(json, false);
}

export function ResponseRocketWarehouseResVoToJSONTyped(value?: ResponseRocketWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': RocketWarehouseResVoToJSON(value['data']),
    };
}

